import { useControlledState } from "features/shared/hooks/useControlledState";
import { type ChangeEvent, type MouseEvent } from "react";
import type { PaginationProps } from "./customTable.types";

export function useCustomTablePagination(
  pagination: PaginationProps | undefined
) {
  const paginationProps =
    pagination === false || pagination == null
      ? null
      : pagination === true
      ? {}
      : pagination;

  const [currentPage, setCurrentPage] = useControlledState({
    defaultValue: paginationProps?.currentPage ?? 0,
    onChange: (newPage) => paginationProps?.onChangePage?.(newPage),
  });

  const [currentRowsPerPage, setCurrentRowsPerPage] = useControlledState({
    defaultValue: paginationProps?.currentRowsPerPage ?? 10,
    onChange: (newRowsPerPage) =>
      paginationProps?.onChangeRowsPerPage?.(newRowsPerPage),
  });

  const handleChangePage = (
    _: MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setCurrentRowsPerPage(newRowsPerPage);
    setCurrentPage(0);
  };

  const hasPagination = paginationProps != null;
  const rowsCount = paginationProps?.count ?? null;
  const rowsPerPageOptions = paginationProps?.rowsPerPageOptions ?? [
    10, 50, 100,
  ];

  return {
    currentPage,
    currentRowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    hasPagination,
    rowsCount,
    rowsPerPageOptions,
  };
}
